<router-outlet></router-outlet>
<app-snow-overlay></app-snow-overlay>
@if (tema$ | async; as tema) {
  @if ((temaRuntime.desactivadoPorUsuario$ | async) === false) {
    <app-tema-overlay
      [efecto]="tema.payload?.efectoFullscreen"
    ></app-tema-overlay>
  }
}
